const AWS_CONFIG = {
  "PRODUCTION": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fcq33Qpux',
      userPoolWebClientId: '6tman1pihgk7hrhced5lsqd9va',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  },
  "STAGING": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fCwVY0DQy',
      userPoolWebClientId: '39rl8mn19ohi2gthbgkafc8qsg',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  },
  "DEV": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fCwVY0DQy',
      userPoolWebClientId: '39rl8mn19ohi2gthbgkafc8qsg',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  },
  "PRODUCTION_EU": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fcq33Qpux',
      userPoolWebClientId: '6tman1pihgk7hrhced5lsqd9va',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  },
  "STAGING_EU": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fCwVY0DQy',
      userPoolWebClientId: '39rl8mn19ohi2gthbgkafc8qsg',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  },
  "DEV_EU": {
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_fCwVY0DQy',
      userPoolWebClientId: '39rl8mn19ohi2gthbgkafc8qsg',
      authenticationFlowType: 'CUSTOM_AUTH'
    }
  }
}
export default AWS_CONFIG;
